import { EventEmitter } from 'events';
import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import MoveMoneyConstants from '../constants/MoveMoneyConstants';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import StringConstants from '../constants/StringConstants';
import { getPaymentHistoryList } from '../utils/PaymentsStatusApiUtils';
import { SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY } from '../actions/PaymentStatusActionCreator';

let backUrl = 'WEB-OPEN-MOVEMONEY';
let hasError = false;
let error = null;
let isShowMore = false;
let paymentHistoryList = [];
let selectedAccountNumber = StringConstants.All;
let paymentStatusList = null;
let customDateSelected = false;
let monthName = '3 months';
let isLoading = false;
let isFetchingMore = false;

class PaymentStatusStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  reset() {
    selectedAccountNumber = StringConstants.All;
    paymentHistoryList = [];
    isShowMore = false;
    hasError = false;
    error = null;
    customDateSelected = false;
    monthName = '3 months';
  }
  setSelectedAccountId(accountId = null) {
    selectedAccountNumber = accountId;
  }
  getSelectedAccountId() {
    return selectedAccountNumber;
  }
  getBackUrl() {
    return backUrl;
  }
  isShowMore() {
    return isShowMore;
  }
  hasError() {
    return hasError;
  }
  getError() {
    return error;
  }
  getPaymentStatusList() {
    return paymentStatusList;
  }
  getPaymentHistoryList() {
    return paymentHistoryList;
  }
  resetPaymentHistoryList() {
    paymentHistoryList = [];
  }
  resetMoveMoneyUrl() {
    backUrl = 'WEB-OPEN-MOVEMONEY';
  }
  getMessageByStatusCode(statusCode) {
    return _.get(paymentStatusList, statusCode);
  }
  setCustomDateSelected(value) {
    customDateSelected = value;
  }
  getCustomDateSelected() {
    return customDateSelected;
  }
  setMonthName(month) {
    monthName = month;
  }
  getMonthName() {
    return monthName;
  }
  isLoading() {
    return isLoading;
  }
  isFetchingMore() {
    return isFetchingMore;
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case AppConstants.LOGOUT_USER:
        this.reset();
        break;
      case MoveMoneyConstants.SET_PAYMENT_STATUS_BACK_URL:
        backUrl = actionData;
        break;
      case MoveMoneyConstants.GET_PAYMENT_HISTORY_LIST:
        isLoading = true;
        hasError = false;
        error = null;
        paymentHistoryList = [];
        getPaymentHistoryList(actionData);
        this.emitChange();
        break;
      case MoveMoneyConstants.FETCH_MORE_PAYMENT_HISTORY:
        isFetchingMore = true;
        isShowMore = true;
        getPaymentHistoryList(actionData);
        this.emitChange();
        break;
      case MoveMoneyConstants.SET_PAYMENT_HISTORY_LIST:
        isLoading = false;
        isFetchingMore = false;
        paymentHistoryList = paymentHistoryList.concat(
          actionData.paymentHistoryList
        );
        isShowMore = actionData.showMore;
        this.emitChange();
        break;
      case MoveMoneyConstants.SET_PAYMENT_HISTORY_ERROR:
        isLoading = false;
        isFetchingMore = false;
        isShowMore = false;
        hasError = true;
        error = actionData.error;
        this.emitChange();
        break;
      case MoveMoneyConstants.SET_PAYMENT_STATUS_LIST:
        paymentStatusList = actionData;
        break;
      case SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY:
        selectedAccountNumber = actionData;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}
export default new PaymentStatusStore();
